"use client";

import { loading } from "@/lib/features/hotel/hotelSlice";
import { useAppSelector } from "@/lib/hooks";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Rating } from "react-simple-star-rating";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Import skeleton CSS

interface RatingFilterProps {
  onRatingChange: (value: number[]) => void;
  value: number[];
}

const RatingFilter = ({ onRatingChange, value }: RatingFilterProps) => {
  const isLoading = useAppSelector(loading);

  const [selectedValues, setSelectedValues] = useState<any[]>([]);
  const data = useMemo(
    () => [
      { label: 5, value: 5 },
      { label: 4, value: 4 },
      { label: 3, value: 3 },
      { label: "Unrated", value: 0 },
    ],
    []
  );

  // useEffect(() => {
  //   if (selectedValues) {
  //     onRatingChange(selectedValues);
  //   }
  // }, [selectedValues]);
  const handleCheckboxChange = useCallback(
    (checkboxValue: string) => {
      const numericValue = Number(checkboxValue);
      const newValues = value.includes(numericValue)
        ? value.filter((val) => val !== numericValue)
        : [...value, numericValue];
      onRatingChange(newValues);
    },
    [value, onRatingChange]
  );
  return (
    <>
      {/* {JSON.stringify(selectedValues)} */}
      {isLoading
        ? // Skeleton loader when isLoading is true
          Array(4)
            .fill(0)
            .map((_, index) => (
              <div className="col-12 mb-2" key={index}>
                <div className="form-checkbox d-flex items-center">
                  <input name="amenities" type="checkbox" disabled={true} />
                  <div className="form-checkbox__mark">
                    <div className="form-checkbox__icon icon-check" />
                  </div>
                  <div className="text-15 ml-10">
                    <Skeleton width={250} height={15} />
                  </div>
                </div>
              </div>
            ))
        : data?.map((item: any, index: number) => (
            <div className="col-12" key={index}>
              <div className="form-checkbox d-flex items-center">
                <input
                  name="star_rating"
                  type="checkbox"
                  value={item?.value}
                  checked={value?.includes(item?.value)}
                  onChange={(e) => handleCheckboxChange(e?.target?.value)}
                  disabled={isLoading}
                />
                <div className="form-checkbox__mark">
                  <div className="form-checkbox__icon icon-check" />
                </div>
                <div className="text-15 ml-10">
                  {item.value ? (
                    <Rating
                      iconsCount={item.value}
                      initialValue={item.value}
                      fillColor="#f8d448"
                      emptyColor="lightgray"
                      size={12}
                      tooltipDefaultText={`${item.value} star hotel`}
                      allowHover={false}
                      showTooltip={false}
                    />
                  ) : (
                    "Unrated"
                  )}
                </div>
              </div>
            </div>
          ))}
    </>
  );
};

export default RatingFilter;
